const uploadToS3ViaPresignedUrl = async (url, body) => {
  await fetch(url, {
    method: "PUT",
    headers: {
      "content-type": body.type,
    },
    body,
  });
};
export default uploadToS3ViaPresignedUrl;
